export type DeviationType = 'COMPLIANCE_BREACH' | 'DEFECT' | 'DEFERRED_MAINTENANCE';
export type TimeframeType =
	| 'IMMEDIATE'
	| 'MAINTENANCE_1_5_YEARS'
	| 'MAINTENANCE_5_10_YEARS';
export type CostAllocationType = 'OWNER' | 'TENANT';
export type RiskLevelType = 'HIGH' | 'LOW' | 'MEDIUM';
export type ConsequenceRatingChoicesType = 'CR0' | 'CR1' | 'CR2' | 'CR3';
export type MaintenanceSelectionTypes =
	| 'DeviationTypeChoices'
	| 'TimeframeChoices'
	| 'CostAllocationChoices'
	| 'RiskLevelChoices'
	| 'ConsequenceRatingChoices';

export type MaintenanceTypes =
	| DeviationType
	| TimeframeType
	| CostAllocationType
	| RiskLevelType
	| ConsequenceRatingChoicesType;

export type MaintenanceEntityDict = {
	[key: string]: string;
};

export const DeviationTypeTranslationKeys: Record<DeviationType, string> = {
	COMPLIANCE_BREACH: 'compliance_breach',
	DEFECT: 'defect',
	DEFERRED_MAINTENANCE: 'deferred_maintenance',
};

export const TimeframeTypeTranslationKeys: Record<TimeframeType, string> = {
	IMMEDIATE: 'immediate',
	MAINTENANCE_1_5_YEARS: 'maintenance_one_to_five_years',
	MAINTENANCE_5_10_YEARS: 'maintenance_five_to_ten_years',
};

export const CostAllocationTypeTranslationKeys: Record<CostAllocationType, string> = {
	OWNER: 'owner',
	TENANT: 'tenant',
};

export const RiskLevelTypeTranslationKeys: Record<RiskLevelType, string> = {
	HIGH: 'high',
	LOW: 'low',
	MEDIUM: 'medium',
};

export const ConsequenceRatingChoicesTypeTranslationKeys: Record<
	ConsequenceRatingChoicesType,
	string
> = {
	CR0: 'consequence_rating_choices_cr0',
	CR1: 'consequence_rating_choices_cr1',
	CR2: 'consequence_rating_choices_cr2',
	CR3: 'consequence_rating_choices_cr3',
};

export const MaintenanceSelectionConfiguration = {
	DeviationTypeChoices: {
		enumValues: [],
		label: 'deviation_type',
	},
	TimeframeChoices: {
		enumValues: [],
		label: 'time_frame',
	},
	CostAllocationChoices: {
		enumValues: [],
		label: 'cost_allocation',
	},
	RiskLevelChoices: {
		enumValues: [],
		label: 'risk',
	},
	ConsequenceRatingChoices: {
		enumValues: [],
		label: 'consequence_rating',
	},
};
